export enum Timezone {
  US_HAWAII = 'US/Hawaii',
  US_ALASKA = 'US/Alaska',
  US_PACIFIC = 'US/Pacific',
  US_MOUNTAIN = 'US/Mountain',
  US_CENTRAL = 'US/Central',
  US_EASTERN = 'US/Eastern',
  CANADA_ATLANTIC = 'Canada/Atlantic',
  MEXICO_BAJA_CALIFORNIA = 'Mexico/BajaCalifornia',
  MEXICO_CHIHUAHUA = 'Mexico/Chihuahua',
  AMERICA_CENTRAL_AMERICA = 'America/CentralAmerica',
  MEXICO_GENERAL = 'Mexico/General',
  UTC = 'UTC',
}

export const availableTimezones: Timezone[] = [
  Timezone.US_HAWAII,
  Timezone.US_ALASKA,
  Timezone.US_PACIFIC,
  Timezone.US_MOUNTAIN,
  Timezone.US_CENTRAL,
  Timezone.US_EASTERN,
  Timezone.CANADA_ATLANTIC,
  Timezone.MEXICO_BAJA_CALIFORNIA,
  Timezone.MEXICO_CHIHUAHUA,
  Timezone.AMERICA_CENTRAL_AMERICA,
  Timezone.MEXICO_GENERAL,
  Timezone.UTC,
];

export enum TimezoneMoment {
  US_HAWAII = 'America/Adak',
  US_ALASKA = 'America/Anchorage',
  US_PACIFIC = 'America/Los_Angeles',
  US_MOUNTAIN = 'America/Phoenix',
  US_CENTRAL = 'America/Chicago',
  US_EASTERN = 'America/New_York',
  CANADA_ATLANTIC = 'America/Halifax',
  MEXICO_BAJA_CALIFORNIA = 'America/Tijuana',
  MEXICO_CHIHUAHUA = 'America/Chihuahua',
  AMERICA_CENTRAL_AMERICA = 'America/Mexico_City',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  MEXICO_GENERAL = 'America/Mexico_City',
  UTC = 'UTC',
}
